var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPortfolio(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28.696,
    height: 37.6,
    viewBox: "0 0 28.696 37.6",
    fill: "#9f9f9f",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_988",
    "data-name": "Rectangle 988",
    width: 28.696,
    height: 37.6
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1230",
    "data-name": "Group 1230",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M63.882,40.711a3.279,3.279,0,1,1,2.979,0,5.061,5.061,0,0,1,3.484,3.932,6.981,6.981,0,1,0-9.947,0,5.061,5.061,0,0,1,3.484-3.932",
    transform: "translate(-51.024 -28.634)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M97.139,57.331a2.547,2.547,0,1,0-.987.2,2.528,2.528,0,0,0,.987-.2",
    transform: "translate(-81.804 -45.838)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M0,37.6H28.7V0H0ZM7.274,8.127a7.7,7.7,0,1,1-.6,2.989,7.651,7.651,0,0,1,.6-2.989M25.525,33.518H3.171v-.767H25.525Zm0-2.411H3.171V30.34H25.525Zm0-2.411H3.171v-.767H25.525Zm0-2.411H3.171v-.767H25.525Zm0-2.411H3.171v-.767H25.525Zm0-2.411H3.171V20.7H25.525Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M87.789,102.468a4.314,4.314,0,0,0-7.945,0,4.268,4.268,0,0,0-.319,1.262.366.366,0,0,1-.026.105,6.967,6.967,0,0,0,8.635,0,.371.371,0,0,1-.026-.105,4.264,4.264,0,0,0-.319-1.262",
    transform: "translate(-69.468 -87.239)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPortfolio);
export default __webpack_public_path__ + "static/media/portfolio.f7f45038.svg";
export { ForwardRef as ReactComponent };